import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { ActivatedRoute } from '@angular/router';
import { RegistrationService } from '@app/registration/registration.service';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-verify-forgot-password',
  templateUrl: './verify-forgot-password.component.html',
  styleUrls: ['./verify-forgot-password.component.scss']
})
export class VerifyForgotPasswordComponent {

   @ViewChild('otpFirst') otpFirstInput!: ElementRef;

   otp: string[] = ['', '', '', '', '', ''];
    //  timerActive =false;
    //  timeRemaining = 0;
    //  timerDisplay = '00:00';
    //  timerInterval: any = null;
     errorMessage = '';
     isResending = false;
   
     isMobile = false;
     logoPath = 'assets/images/edu-logo.svg';
     resizeObservable$: Subscription | undefined;
       fromPage: string;
  email: string;
  readonly correctPhoneOtp: string = '628170';
  // recoveryResendCount: number = 0;
// maxResendCount: number = 5;
// recoveryResendDisabledUntil: number | null = null;
// recoveryTimeRemaining: number = 0;
// recoveryTimerInterval: any = null;
// phoneResendCount: number = 0;
// maxPhoneResendCount: number = 5;
// phoneResendDisabledUntil: number | null = null;
// phoneTimeRemaining: number = 0;
// phoneResendTimer: number = 30; // 30 seconds
// phoneTimerInterval: any = null;
// isPhoneBlocked: boolean = false;
resendCount: number = 0;
maxResendCount: number = 5;
resendDisabledUntil: number | null = null;
timeRemaining: number = 0;
timerInterval: any = null;
isBlocked: boolean = false;
timerActive: boolean = false;
timerDisplay: string = '00:00';
phoneTimerStateKey = 'phoneTimerState';
 mode: string;
 method: string;

   
     constructor(private readonly router: Router, private readonly appLoginService: AppLoginService,private route: ActivatedRoute,
      private registrationService: RegistrationService , private sessionStorage: LocalService,
     ) {}
   
     ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
      this.mode = params['mode'];
      this.method = params['method'];
      this.fromPage = params['from'];
      this.email = params['email'];
      const phone = params['phone'];
     if (this.fromPage === 'forgot-password-phone' && phone) {
      // Call API to get email by phone
      this.registrationService.getPrimaryEmailByPhone({ primaryPhone: phone }).subscribe({
        next: (response: any) => {
          const email =
            response?.data?.data?.[0]?.primary_email ||
            response?.email ||
            null;
          if (email) {
            this.email = email;
            this.sessionStorage.setItem('email', email);
          } 
        },
       
      });
    }
  if ((this.mode === '2fa' && this.method === 'email') || this.fromPage === 'forgot-password-email') {
        this.setupEmailResendState();
      } else if ((this.mode === '2fa' && this.method === 'phone') || this.fromPage === 'forgot-password-phone') {
        this.setupPhoneResendState();
      } else if (this.fromPage === 'find-account') {
        this.verifyEmail(this.email);
      }
    });
    this.focusFirstInput();
    this.setupResponsiveImage();

}

private setupEmailResendState() {
  const lockoutUntil = Number(localStorage.getItem('recoveryResendDisabledUntil') || '0');
  if (lockoutUntil && Date.now() < lockoutUntil) {
    this.resendDisabledUntil = lockoutUntil;
    this.timeRemaining = Math.ceil((lockoutUntil - Date.now()) / 1000);
    this.isBlocked = true;
    this.startTimer();
  } else {
    this.resendDisabledUntil = null;
    this.timeRemaining = 0;
    this.resendCount = 0;
    localStorage.removeItem('recoveryResendDisabledUntil');
    this.isBlocked = false;
  }
}

private setupPhoneResendState() {
  const phoneTimerState = JSON.parse(this.sessionStorage.getObj(this.phoneTimerStateKey) || '{}');
  if (phoneTimerState && phoneTimerState.lockoutUntil && Date.now() < phoneTimerState.lockoutUntil) {
    this.resendDisabledUntil = phoneTimerState.lockoutUntil;
    this.timeRemaining = Math.ceil((phoneTimerState.lockoutUntil - Date.now()) / 1000);
    this.resendCount = phoneTimerState.resendCount || 0;
    this.isBlocked = true;
    this.startTimer();
  } else if (phoneTimerState && phoneTimerState.timeRemaining && phoneTimerState.timeRemaining > 0) {
    this.timeRemaining = phoneTimerState.timeRemaining;
    this.resendCount = phoneTimerState.resendCount || 0;
    this.isBlocked = false;
    this.startTimer();
  } else {
    this.resendDisabledUntil = null;
    this.timeRemaining = 0;
    this.resendCount = 0;
    this.sessionStorage.removeItem(this.phoneTimerStateKey);
    this.isBlocked = false;
  }
}

       verifyEmail(email: string) {
    // Call your API here
  }
     
     private focusFirstInput(): void {
       setTimeout(() => {
         if (this.otpFirstInput?.nativeElement) {
           this.otpFirstInput.nativeElement.focus();
         }
       }, 0);
     }

     startTimer() {
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
  }
  this.timerActive = true;
  this.updateTimerDisplay();
  this.timerInterval = setInterval(() => {
    if (this.timeRemaining > 0) {
      this.timeRemaining--;
      this.updateTimerDisplay();
      // Persist phone timer state if phone flow
      if (this.fromPage === 'forgot-password-phone') {
        this.sessionStorage.setObj(this.phoneTimerStateKey, {
          timeRemaining: this.timeRemaining,
          lockoutUntil: this.resendDisabledUntil,
          resendCount: this.resendCount
        });
      }
    } else {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      this.timerActive = false;
      if (this.fromPage === 'forgot-password-email') {
        this.resendDisabledUntil = null;
        localStorage.removeItem('recoveryResendDisabledUntil');
        this.resendCount = 0;
      } else if (this.fromPage === 'forgot-password-phone') {
        this.sessionStorage.removeItem(this.phoneTimerStateKey);
        this.resendDisabledUntil = null;
        this.resendCount = 0;
        this.isBlocked = false;
      }
    }
  }, 1000);
}
   
     ngOnDestroy(): void {
       this.clearTimer();
       if (this.resizeObservable$) {
         this.resizeObservable$.unsubscribe();
       }
     }
   
     setupResponsiveImage(): void {
   
       this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
         .subscribe(() => {
           this.isMobile = window.innerWidth < 768;
           this.updateLogoPath();
         });
   
       this.isMobile = window.innerWidth < 768;
       this.updateLogoPath();
     }
   
     updateLogoPath(): void {
       this.logoPath = this.isMobile 
         ? 'assets/images/cardy-ai/mobile-logo.svg'
         : 'assets/images/edu-logo.svg';
     }
   
    //  startTimer(): void {
    //    this.clearTimer();
    //    this.timerActive = true;
    //    this.timeRemaining = 30;
    //    this.updateTimerDisplay();
       
    //    this.timerInterval = setInterval(() => {
    //      this.timeRemaining--;
    //      this.updateTimerDisplay();
         
    //      if (this.timeRemaining <= 0) {
    //        this.clearTimer();
    //        this.timerActive = false;
    //        this.errorMessage = 'OTP expired. Please request a new verification code.';
    //      }
    //    }, 1000);
    //  }
   
    clearTimer(): void {
  if (this.timerInterval !== null) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
  this.timerActive = false;
}
   
   updateTimerDisplay(): void {
  const minutes = Math.floor(this.timeRemaining / 60);
  const seconds = this.timeRemaining % 60;
  this.timerDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
   
     onOtpChange(index: number, event: Event): void {
       const input = event.target;
       
       if (!(input instanceof HTMLInputElement)) {
         return;
       }
       
       if (input.value) {
         const numericValue = input.value.replace(/\D/g, '');
         if (input.value !== numericValue) {
           input.value = numericValue;
         }
         this.otp[index] = numericValue;
       }
       
       if (input.value && index < 5) {
         const nextElement = input.parentElement?.children?.[index + 1];
         if (nextElement instanceof HTMLInputElement) {
           nextElement.focus();
         }
       }
       
       if (input.value === '' && index > 0) {
         const prevElement = input.parentElement?.children?.[index - 1];
         if (prevElement instanceof HTMLInputElement) {
           prevElement.focus();
         }
       }
     }
   
resendOtp(): void {
  if (this.isBlocked || (this.resendDisabledUntil && Date.now() < this.resendDisabledUntil)) {
    this.errorMessage = 'Resend Code is disabled due to too many failed attempts. Please try again after 15 minutes.';
    return;
  }
  if (this.resendCount >= this.maxResendCount) {
    // Block for 15 minutes
    this.isBlocked = true;
    this.resendDisabledUntil = Date.now() + 15 * 60 * 1000;
    this.timeRemaining = 15 * 60;
    this.updateTimerDisplay();
    this.startTimer();
    if (this.fromPage === 'forgot-password-email') {
      localStorage.setItem('recoveryResendDisabledUntil', this.resendDisabledUntil.toString());
    } else if (this.fromPage === 'forgot-password-phone') {
      this.sessionStorage.setObj(this.phoneTimerStateKey, {
        timeRemaining: this.timeRemaining,
        lockoutUntil: this.resendDisabledUntil,
        resendCount: this.resendCount
      });
    }
    this.errorMessage = 'Resend Code is disabled due to too many failed attempts. Please try again after 15 minutes.';
    return;
  }
  // Send OTP only for email flow
  if (this.fromPage === 'forgot-password-email' && this.email) {
    const request = { email: this.email };
    this.registrationService.sendPrimaryEmailOtp(request).subscribe({
      next: () => {
        this.resendCount++;
        this.errorMessage = '';
        this.timeRemaining = 30;
        this.updateTimerDisplay();
        this.startTimer();
      },
      error: () => {
        this.errorMessage = 'Failed to resend OTP. Please try again.';
      }
    });
  } else if (this.fromPage === 'forgot-password-phone') {
    // No OTP API call for phone, just increment and start timer
    this.resendCount++;
    this.errorMessage = '';
    this.timeRemaining = 30;
    this.updateTimerDisplay();
    this.startTimer();
    this.sessionStorage.setObj(this.phoneTimerStateKey, {
      timeRemaining: this.timeRemaining,
      lockoutUntil: null,
      resendCount: this.resendCount
    });
  } else {
    this.errorMessage = 'Email not found. Please go back and enter your email again.';
  }
}
   
     verifyOtp(): void {
       const otpValue = this.otp.join('');
       
       if (otpValue.length < 6) {
         this.errorMessage = 'Please enter the complete 6-digit verification code.';
         return;
       }
   
       this.errorMessage = '';
       this.clearTimer();
      //  this.router.navigate(['app-login/confirmation-screen']);
          if ((this.mode === '2fa' && this.method === 'phone') || this.fromPage === 'forgot-password-phone') {
      // Hardcoded OTP verification for phone flow
      if (otpValue === this.correctPhoneOtp) {
        // Success: Navigate to set new password
        this.sessionStorage.setItem('email', this.email);
        // this.router.navigate(['app-login/set-New-Password']);
        if (this.mode === '2fa') {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['app-login/set-New-Password']);
        }
      } else {
        // Failure: Show error and restart timer
        this.errorMessage = 'Invalid or expired verification code.';
        this.startTimer();
      }
      return;
    }
      if ((this.mode === '2fa' && this.method === 'email') || this.fromPage === 'forgot-password-email') {
    // Call verifyRecoveryEmail API
    const request = {
      email: this.email,
      otp: otpValue
    };
    this.registrationService.verifyPrimaryEmailOtp(request).subscribe({
      next: (response) => {
        // Only navigate if OTP is valid
        if (response?.data?.success) {
          this.sessionStorage.setItem('email', this.email);
          // this.router.navigate(['app-login/set-New-Password']);
          if (this.mode === '2fa') {
            this.router.navigate(['/login']);
          } else {
            this.router.navigate(['app-login/set-New-Password']);
          }
        } else {
          this.errorMessage = response?.data?.message || 'Invalid or expired verification code.';
          this.startTimer();
        }
      },
      error: () => {
        // Handle error
        this.errorMessage = 'Invalid or expired verification code.';
        this.startTimer();
      }
    });
    return;
  }
      this.router.navigate(['app-login/confirmation-screen']);
     }
   
     cancel(): void {
       this.router.navigate(['app-login/find-account']);
     }
     
     onlyNumeric(event: KeyboardEvent): boolean {
       // Use event.key instead of deprecated keyCode
       const key = event.key;
       const isNumber = /^\d$/.test(key);
       const isControlKey = event.ctrlKey || event.altKey || 
                            key === 'Tab' || 
                            key === 'Delete' || 
                            key === 'Backspace' ||
                            key === 'ArrowLeft' || 
                            key === 'ArrowRight' ||
                            key === 'Home' ||
                            key === 'End';
       
       if (!isNumber && !isControlKey) {
         event.preventDefault();
         return false;
       }
       return true;
     }

//      resendPhoneOtp(): void {
//   if (this.phoneResendDisabledUntil && Date.now() < this.phoneResendDisabledUntil) {
//     this.isPhoneBlocked = true;
//     this.errorMessage = 'Resend Code is disabled due to too many failed attempts. Please try again after 15 minutes.';
//     return;
//   }
//   if (this.phoneResendCount === this.maxPhoneResendCount) {
//     this.isPhoneBlocked = true;
//     const lockoutUntil = Date.now() + 15 * 60 * 1000;
//     this.phoneResendDisabledUntil = lockoutUntil;
//     this.phoneTimeRemaining = 15 * 60;
//     this.startPhoneTimer();
//     sessionStorage.setItem('phoneTimerState', JSON.stringify({
//       timeRemaining: this.phoneTimeRemaining,
//       lockoutUntil: lockoutUntil,
//       resendCount: this.phoneResendCount
//     }));
//     this.errorMessage = 'Resend Code is disabled due to too many failed attempts. Please try again after 15 minutes.';
//     return;
//   }
//   this.phoneResendCount++;
//   this.phoneTimeRemaining = this.phoneResendTimer;
//   this.startPhoneTimer();
//   this.isPhoneBlocked = false;
//   this.errorMessage = '';
//   sessionStorage.setItem('phoneTimerState', JSON.stringify({
//     timeRemaining: this.phoneTimeRemaining,
//     lockoutUntil: null,
//     resendCount: this.phoneResendCount
//   }));
//   // Optionally: Show a toast or message "Verification code has been resent to your phone."
// }

// startPhoneTimer() {
//   if (this.phoneTimerInterval) {
//     clearInterval(this.phoneTimerInterval);
//   }
//   this.phoneTimerInterval = setInterval(() => {
//     if (this.phoneTimeRemaining > 0) {
//       this.phoneTimeRemaining--;
//       sessionStorage.setItem('phoneTimerState', JSON.stringify({
//         timeRemaining: this.phoneTimeRemaining,
//         lockoutUntil: this.phoneResendDisabledUntil,
//         resendCount: this.phoneResendCount
//       }));
//     } else {
//       clearInterval(this.phoneTimerInterval);
//       this.phoneTimerInterval = null;
//       sessionStorage.removeItem('phoneTimerState');
//       this.phoneResendDisabledUntil = null;
//       this.isPhoneBlocked = false;
//       this.phoneResendCount = 0;
//     }
//   }, 1000);
// }
}
